export default __webpack_public_path__ + "static/wallet-4c9b1e0b3376ffc7ff748e415b04d98286ec1a4b0e81b9efa94d8bcac4d12d86.png";